/* Part numbers as printed on quotes and invoices — "11007/Charcoal/6090".
   Shopify's search does not treat "/" as a word separator, so the pasted
   string matches nothing at all: checked against the live store,
   "thickness13mm/black" returns 0 results where "thickness13mm black"
   returns 28.

   The whole part number is reduced to its five-digit base, which is the part
   carried by a product tag. Keeping the colour and size as extra words looked
   tempting but measurably fails: predictive search requires every term to
   match, so "11007 Charcoal 6090" returns nothing from the dropdown, and on
   the results page the extra words dilute the ranking enough to push the
   right product off the top. The base alone is unique to one product — no
   base is shared across two products in the catalogue — so it lands exactly
   one result, and the page then shows the full number per variant.

   Deliberately narrow: it fires only on a leading five-digit group joined to
   something by "/", "-", "\" or "|", and any words the customer typed after
   it are left alone. Widening the trigger would quietly change results
   storewide. The known cost is a query like "10000-15000" being read as a
   part number; that is judged rarer than a pasted part number. */
const FM_PART_NUMBER_QUERY = /^(\s*)(\d{5})(?:[/\\|-][A-Za-z0-9.]+)+(\s|$)/;

function fmNormalizePartNumberQuery(term) {
  if (typeof term !== 'string') return term;
  return term.replace(FM_PART_NUMBER_QUERY, '$1$2$3').trim();
}

class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');
  
      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.form.addEventListener('submit', this.onNormalizeQuery.bind(this));
        this.input.addEventListener(
          'input',
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this)
        );
      }
    }
  
    toggleResetButton() {
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }
  
    onChange() {
      this.toggleResetButton();
    }

    /* Rewrites a part-number query in place as the form is submitted, so the
       results page receives separators the search engine can actually split. */
    onNormalizeQuery() {
      const normalized = fmNormalizePartNumberQuery(this.input.value);
      if (normalized !== this.input.value) this.input.value = normalized;
    }
  
    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }
  
    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  }
  
  customElements.define('search-form', SearchForm);
  